import CustomerConfig from '../azure/CustomerConfig';
import AuthTeams from './AuthTeams';
import axios from "axios";

export default class IfsAuth {

  async isValidAuthenticated(authChannel) {
    // You can implement real logic here later
    return true;
  }

}